import Utility from "../../classes/utility";

class AlumniBusinessCustomRender {
    static customRender(item)
    {
        item.id = Utility.randomLetters(12);
        try {
            if (item.relatedPrograms.length != 0) {
                item.relatedProgramsActive = true;

                // decode program name if there are weird characters
                item.relatedPrograms.forEach(rp => {
                    rp.name = Utility.htmlDecode(rp.name);
                });
            }
        } catch {
            // silent fail
        }
        if (Object.hasOwn(item.recordObj, "website")) {
            item.websiteDisplay = item.recordObj.website;
            item.websiteDisplay = item.websiteDisplay.replace("https://", "");
            item.websiteDisplay = item.websiteDisplay.replace("www.", "");
            item.websiteDisplay = item.websiteDisplay.endsWith('/') ? item.websiteDisplay.slice(0, -1) : item.websiteDisplay;
        }

        if (!Object.hasOwn(item, 'decoded')) {
            item.decoded = true;
            //item.title = Utility.htmlDecode(item.title);
            //item.description = Utility.htmlDecode(item.description);
        }
        // console.log(item);
        return item;
    }
}

export default AlumniBusinessCustomRender;